import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const AdminHeader = () => {
  const { logout, displayName } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="admin-header">

      <span className="admin-header-title">
        Admin Panel
      </span>

      <div className="admin-header-actions">

        {displayName && (
          <span className="admin-name">
            {displayName}
          </span>
        )}

        <button
          className="admin-logout-btn"
          onClick={handleLogout}
        >
          Logout
        </button>

      </div>

    </header>
  );
};

export default AdminHeader;